import { Controller } from "@hotwired/stimulus"

// connect/disconnect are used here intentionally: this controller exists solely to poll
// for an async webhook confirmation after Stripe checkout. There is no Turbo Frame
// equivalent for waiting on a cross-process event, making lifecycle callbacks unavoidable.
export default class extends Controller {
  connect() {
    this.scheduleCheck()
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  scheduleCheck() {
    this.timeout = setTimeout(() => this.check(), 5000)
  }

  async check() {
    try {
      const response = await fetch(window.location.href, {
        headers: { Accept: "text/html" },
        redirect: "follow"
      })
      if (response.redirected) {
        Turbo.visit(response.url)
      } else {
        this.scheduleCheck()
      }
    } catch (_err) {
      this.scheduleCheck()
    }
  }
}
